import React from 'react'
import { Bar } from 'react-chartjs-2'
// import ChartDataLabels from 'chartjs-plugin-datalabels';


const YearAvgChart = ({ years, totalUsage, totalProduction, loan1Bills, loan2Bills }) => {



  const total = (arr) => arr.reduce((a, b) => a + b)




  return (
    <div>
      <Bar
        data={{
          labels: ['Utility Power', 'Option 1', 'Option 2'],
          datasets: [
            {
              barThickness: 70,
              label: '25 Year Average $',
              datalabels: {
                anchor: 'end',
                align: 'top',
                color: 'black',
                // clamp: true,
                formatter: function (value) {
                  return "$" + value;
                },
                font: {
                  // size: 15,
                  // family: 'PT Sans, sans-serif'
                }
              },
              data: [
                (((total(years) * 12) / 25) / totalUsage).toFixed(3),
                (((total(loan1Bills) * 12) / 25) / totalProduction).toFixed(3),
                (((total(loan2Bills) * 12) / 25) / totalProduction).toFixed(3),

              ],
              backgroundColor: [
                'rgba(255, 34, 34, 0.98)',
                'rgba(71, 93, 203, 0.98)',
                'rgba(18, 42, 162, 0.98)',

              ]
            }
          ]
        }}
        options={{
          // DataLabels: {
          //   anchor: 'end',
          //   align: 'end',  
          //   fontColor: 'black'
          // },
          title: {
            display: true,
            text: '',
            fontSize: 25,
            fontColor: '#000'
          },
          legend: {
            display: false,
            position: 'bottom',
            labels: { fontColor: '#000' }
          }, scales: {
            xAxes: [{

              ticks: {
                display: false,
                // scaleBeginAtZero : true,

              },
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                callback: function (value, index, values) {
                  return '$' + value.toFixed(2);
                }
              },
              gridLines: {
                color: "rgba(0, 0, 0, 0)",
              }
            }]
          }
        }} height={182}
        width={507}

      />
    </div>
  )

}




export default YearAvgChart